import { currentEnv } from './endpoints';

export const KAFKA_TOPICS = {
    UI_INTERACTION: `${ currentEnv ? currentEnv : 'prod' }-ui-interaction`
};

export const CLICK_EVENT_ACTIONS = {
    MERCHANDISE: 'MERCHANDISE_MARKETPLACE_REDIRECT',
    EXPERIENCES: 'EXPERIENCES_MARKETPLACE_REDIRECT',
    MASTERY: 'MASTERY_MARKETPLACE_REDIRECT',
    CULINARY: 'CULINARY_MARKETPLACE_REDIRECT'
};